const actionLogMessages = {
  'actionLog.title': 'アクティビティログ',
  'actionLog.list.header.operator': '作業者',
  'actionLog.list.header.group': 'グループ',
  'actionLog.list.header.device': 'デバイス',
  'actionLog.list.header.location': '位置情報/IPアドレス',
  'actionLog.list.header.date': '実施日時',
  'actionLog.list.header.action': 'アクション',
  'actionLog.list.header.data': 'データ',
  'actionLog.list.actions': {
    login: 'ログイン',
    company_select: '企業選択',
    logout: 'ログアウト',
    photograph: '撮影',
    movie_recording: '録画',
    voice_recording: '録音',
    download: 'ダウンロード',
    device_auth_code_issue_first: '認証コード発行（初回）',
    device_auth_code_issue: '認証コード発行',
    device_auth_failure: '認証コード認証失敗',
    device_auth_failure_over_count: '認証コード指定回数失敗',
    device_auth_failure_expired: '認証コード有効期限切れ',
    device_auth_success: '認証コード認証成功',
  },
  'actionLog.list.map': '地図',
  'actionLog.list.location.delimiter': ' / ',
  'actionLog.searchBox.title.date': '実施日時',
  'actionLog.searchBox.title.device': 'デバイス',
  'actionLog.searchBox.title.operator': '作業者名',
  'actionLog.searchBox.title.group': 'グループ',
  'actionLog.searchBox.title.action': 'アクション',
  'actionLog.searchBox.fullTilde': '～',
  'actionLog.searchBox.placeholder.operator': '作業者名で絞り込み',
  'actionLog.searchBox.placeholder.device': 'デバイス名で絞り込み',
  'actionLog.searchBox.error.message.date':
    '実施日時の入力に誤りがあります。3ヶ月以内の範囲で設定してください。',
  'actionLog.button.search': '検索',
  'actionLog.button.csvExport': 'CSVエクスポート',
  'actionLog.media.title': '記録データ',
  'actionLog.detail.title': 'ダウンロードデータ詳細',
  'actionLog.detail.data': 'データ',
  'actionLog.detail.date': '記録日時',
  'actionLog.detail.operator': '作業者',
  'actionLog.detail.number': '{number} 件',
};

export default actionLogMessages;
